import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CHECK_CHECK: GlameraIconDefinition = {
  name: 'check-check',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-check-check-tick glm-check-check-tick-1" d="M18 6 7 17l-5-5"></path>
    <path class="glm-check-check-tick glm-check-check-tick-2" d="m22 10-7.5 7.5L13 16"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-check-check-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './check-check.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CheckCheckIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CHECK_CHECK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
